import { render, staticRenderFns } from "./roleMenuRelationship.vue?vue&type=template&id=32f1747c&scoped=true&"
import script from "./roleMenuRelationship.vue?vue&type=script&lang=js&"
export * from "./roleMenuRelationship.vue?vue&type=script&lang=js&"
import style0 from "./roleMenuRelationship.vue?vue&type=style&index=0&id=32f1747c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f1747c",
  null
  
)

export default component.exports